module.exports = __webpack_public_path__ + "images/emoji/gb.0b19adfa46db5112d021.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/gb.png
// module id = TrQY
// module chunks = 14